export default "__VITE_ASSET__a9aa9696__"